import MachineForm from "@/components/forms/MachineForm";

export default function NewMachinePage() {
  return <MachineForm edit={false} />;
}
